export const cacheTypes: Record<string, string> = {
  contextual_task: "Contextual task",
  rag: "RAG",
  other: "Other",
};
